import { api } from "./api";

export const storeListsApiSlice = api.injectEndpoints({
  endpoints: (builder) => ({
    getStoreLists: builder.query({
      query: () => `/getStoreList`,
      providesTags: ["storeLists"],
    }),
    getStoreById: builder.query({
      query: ({ id }) => `/getStoreByID?id=${id}`,
    }),
    getStoreDistance: builder.query({
      query: ({ zipCode, lat = "", long = "", productId = "", storeId = "" }) => {
        let queryString = `/getStoreDistance?`;
        const params = [];
    
        if (lat && long) {
          params.push(`latitude=${lat}`, `longitude=${long}`, `storeId=${storeId}`);
        }
        if (zipCode) {
          params.push(`zipCode=${zipCode}`);
        }
        if (productId) {
          params.push(`productId=${productId}`);
        }
    
        queryString += params.join("&");
        return queryString;
      },
    }),
  }),
});

export const {
  useGetStoreListsQuery,
  useGetStoreByIdQuery,
  useGetStoreDistanceQuery,
  useLazyGetStoreDistanceQuery,
} = storeListsApiSlice;
